(ns frontend.view.modals.hidden-emails.view
  "Modal for viewing and managing hidden emails."
  (:require
   [common.localization :as loc]
   [frontend.view.modals.hidden-emails.events :as events]
   [frontend.view.settings2.connected-plugins.sub :as plugin-sub]
   [re-frame.core :as rf]
   [ui.color :as c]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]))

(defonce modal-key ::hidden-emails-modal)

(defn- email-row
  "A single hidden email row with unhide button"
  [email close-modal! last-email?]
  (let [unhiding? @(rf/subscribe [::events/unhiding?])]
    [:div
     {:class "p-3 flex items-center justify-between border border-solid border-base-light-border-paler rounded"}
     [:div
      {:class "flex items-center gap-2 min-w-0 flex-1"}
      [:i.fal.fa-envelope.text-base-light-text-paler.flex-shrink-0.w-4.text-center]
      [:span {:class "text-sm truncate m-0"} email]]
     [:div
      {:class "flex-shrink-0 ml-2"}
      [button/sm-secondary-hollow
       {:on-click #(rf/dispatch [::events/unhide-email
                                 {:email        email
                                  :close-modal! (when last-email? close-modal!)}])
        :disabled unhiding?}
       (if unhiding?
         [:i.fal.fa-spinner.fa-spin]
         (loc/tr :settings/unhide-email))]]]))

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (fn [{:keys [shown? close-modal! props state class-name topmost?]}]
    (let [hidden-emails @(rf/subscribe [::plugin-sub/hidden-emails])
          last-email? (= 1 (count hidden-emails))]
      [modal/view
       {:visible?      (and shown? topmost?)
        :hide!         close-modal!
        :backdrop      true
        :color         ::c/primary
        :close-button? true}
       (loc/tr :settings/hidden-emails)
       [:div
        {:class "flex flex-col gap-3"}
        [:p
         {:class "text-sm text-base-light-text-paler"}
         (loc/tr :settings/hidden-emails-description)]

        (if (empty? hidden-emails)
          [:div
           {:class "p-4 border border-solid border-base-light-border-paler rounded text-center text-base-light-text-paler"}
           [:i.fal.fa-envelope-open.mr-2]
           [:span {:class "text-sm"} (loc/tr :settings/no-hidden-emails)]]

          [:div
           {:class "flex flex-col gap-2 max-h-80 overflow-y-auto"}
           (for [email hidden-emails]
             ^{:key email}
             [email-row email close-modal! last-email?])])]
       [modal/left-single-button-hollow
        ::c/secondary
        false
        (fn [_] (close-modal!))
        (loc/tr :close)]])))
